import NextImage from 'next/image'
import { Nameplate } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { PrunedCourse } from 'libs/server/api'
import { Data } from './types'
import classes from './Hero.module.scss'

export const DefaultNameplateMobile = ({ data }: { data: Data }) => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()

  if (data.isDynamicNameplate) {
    /* based on AlternativeNameplate from components/HighContrastHero/components/HeroContent */
    return (
      <div className='mc-my-3'>
        <div className='d-flex flex-column align-items-start'>
          <h1
            className={`mc-text-d1 mc-text--brand mc-text--uppercase ${classes.alternativeNameplate}`}
          >
            {data.header}
          </h1>
          <h2 className='mc-text-h4 mc-mt-4'>{data.nameplate}</h2>
        </div>
      </div>
    )
  }

  if (!course.leftAlignedNameplate) return null

  const nameplate =
    course.slug === 'the-power-playbook' // Workaround for https://ourmasterclass.slack.com/archives/C02S9J0L0DN/p1758902506859879
      ? data.nameplate
      : course.leftAlignedNameplate

  return (
    <>
      <div className='mc-my-3'>
        <Nameplate
          size='small'
          image={
            <h1 className='mc-w-100 d-flex align-items-start justify-content-start mc-mb-3'>
              <NextImage
                alt={course.instructorName || ''}
                className={classes.nameplateImage}
                src={nameplate || ''}
                objectFit='contain'
                sizes='150px'
                layout='fill'
                priority
              />
            </h1>
          }
          subText={data.header || ''}
          className={classes.nameplate}
          align='bottom'
        />
      </div>
    </>
  )
}
